// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(min-width: 1024px)";
var _4 = "(max-width: 1024px)";
var _5 = "price__wrapper-2-gFi";
var _6 = "price-1b0M-";
var _7 = "image-1twVk";
var _8 = "description-32Fqa";
var _9 = "features-3iZuR";
var _a = "feature-28c-l";
var _b = "seat-2zxAD";
var _c = "title-vQX0q";
var _d = "info-2IGe9";
var _e = "freeSeat__container-3I5Aq";
var _f = "seat_preferred-2q4W3";
var _10 = "serviceInfo__seat-2HdOv";
var _11 = "header-3-SRz";
var _12 = "freeSeat__seat-36Bnx";
var _13 = "seat_free-1gc82";
var _14 = "seat__info-DguG4";
var _15 = "note-1YhZ5";
export { _1 as "__esModule", _2 as "mobile", _3 as "desktop_only", _4 as "tablet", _5 as "price__wrapper", _6 as "price", _7 as "image", _8 as "description", _9 as "features", _a as "feature", _b as "seat", _c as "title", _d as "info", _e as "freeSeat__container", _f as "seat_preferred", _10 as "serviceInfo__seat", _11 as "header", _12 as "freeSeat__seat", _13 as "seat_free", _14 as "seat__info", _15 as "note" }
export default { "__esModule": _1, "mobile": _2, "desktop_only": _3, "tablet": _4, "price__wrapper": _5, "price": _6, "image": _7, "description": _8, "features": _9, "feature": _a, "seat": _b, "title": _c, "info": _d, "freeSeat__container": _e, "seat_preferred": _f, "serviceInfo__seat": _10, "header": _11, "freeSeat__seat": _12, "seat_free": _13, "seat__info": _14, "note": _15 }
